import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { LinkButton, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { TOfferFromHistoryData } from '../../../../../store/offerHistory';
import { Price, Error, Loading, DeactivatedLabel, KeyValTable, AuthError } from '../../commonComponents';
import { OfferGallery } from '../OfferGallery';
import * as styles from './styles.css';

export interface IOfferFromHistoryProps {
  offer?: TOfferFromHistoryData | null;
  isDeactivated: boolean;
  isLoading?: boolean;
  isError?: boolean;
  isAuthError?: boolean;
  onAuthErrorClick(): void;
  onOfferShow(): void;
  onGalleryScroll(): void;
  onGalleryClick(): void;
  onRedirectToOfferClick(): void;
}

export const OfferFromHistory: React.VFC<IOfferFromHistoryProps> = props => {
  const {
    offer,
    isLoading,
    isError,
    isAuthError,
    isDeactivated,
    onOfferShow,
    onGalleryScroll,
    onGalleryClick,
    onRedirectToOfferClick,
    onAuthErrorClick,
  } = props;

  const information = React.useMemo(() => {
    if (isLoading) {
      return <Loading height={300} />;
    }

    if (isAuthError) {
      return <AuthError onClick={onAuthErrorClick} />;
    }

    if (isError) {
      return <Error />;
    }

    return null;
  }, [isAuthError, isError, isLoading, onAuthErrorClick]);

  return (
    <>
      {offer && !isError && !isAuthError && (
        <ActionAfterViewObserver callback={onOfferShow} triggerOnce={false} wrapper={false}>
          <div data-testid="offers_history_full_offer">
            <div className={styles['gallery']}>
              <OfferGallery images={offer.images} onScroll={onGalleryScroll} onClick={onGalleryClick} />
            </div>

            <div className={styles['price']}>
              <Price size="M" diff={offer.prices.priceDiff} subprice={offer.prices.priceSqm}>
                {offer.prices.price}
              </Price>
              {isDeactivated && <DeactivatedLabel />}
            </div>
            <div className={styles['title']}>
              <UIText1>{offer.title}</UIText1>
            </div>
            <div className={styles['address']}>
              <UIText2 color="gray60_100">{offer.address}</UIText2>
            </div>
            {offer.kpName && (
              <div className={styles['kp']}>
                <UIText1>{offer.kpName}</UIText1>
              </div>
            )}
            <KeyValTable size="M" className={styles['features']} table={offer.features} />
            {offer.link && (
              <div className={styles['redirect-btn']}>
                <LinkButton size="XS" href={offer.link} theme="fill_secondary" onClick={onRedirectToOfferClick}>
                  Посмотреть объявление
                </LinkButton>
              </div>
            )}
          </div>
        </ActionAfterViewObserver>
      )}
      {information}
    </>
  );
};
